module.exports = __webpack_public_path__ + "static/media/return.1876cd37.svg";